// extracted by mini-css-extract-plugin
module.exports = {"background":"_1zWn-313","hero":"_28Nr-IEo","subtitle":"_3ADfg0HG _1d0WKk0g _2EfiFhQ- _3mW2gstu"};